const UserRoles = Object.freeze({
    ADMIN: 1,
    HR: 2,
    INTERVIEWER: 3
});

export default UserRoles;
